import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { ElementName } from '../../../../../constants';
import { useFlexibleUiContext } from '../../../../../state/flexible-ui-context';
import { BaseAtlaskitBadgeElement, toAtlaskitBadgeProps } from '../common';
var StoryPointsElement = function StoryPointsElement(props) {
  var context = useFlexibleUiContext();
  var data = context ? toAtlaskitBadgeProps(context.storyPoints) : null;
  return data ? /*#__PURE__*/React.createElement(BaseAtlaskitBadgeElement, _extends({}, data, props, {
    name: ElementName.StoryPoints
  })) : null;
};
export default StoryPointsElement;